/**
 *    Video - with overlay
 */

(function ($) {
  Drupal.behaviors.videoWithOverlay = {
    attach() {
      $('.vb-video-with-overlay').each(function () {
        const $this = $(this);
        const $playButton = $this.find('[data-vb-video-play]');
        const $overlay = $this.find('.vb-video-overlay');
        const $videoIframe = $this.find('iframe');
        const $owlCarousel = $this.closest('.owl-carousel');

        if ($videoIframe.length) {
          $playButton.on('click', () => {
            $overlay.hide();
            // stop owl carousel
            if ($owlCarousel.length) {
              $owlCarousel.trigger('stop.owl.autoplay');
            }
            // play video
            $videoIframe.attr('src', $videoIframe.attr('src').replace('autoplay=0', 'autoplay=1'));
          });
        }
      });
    },
  };
}(jQuery));
